module.exports = __webpack_public_path__ + "static/EnmTX_BosLizardman_L_A_cl-ad91e7667b24fa88a1e478ca712b0ca1.gif";